<ion-content class="ion-padding">
    <ion-refresher slot="fixed" libRefreshWindow>
        <ion-refresher-content />
    </ion-refresher>
    <section class="narrow-width vertically-centered text-center">
        <picture>
            <img alt="Logo icon" class="logo" src="/assets/logos/logo-icon-color-name-black.svg" />
        </picture>
        <div class="page-title ion-padding-top" libInsertRouteTitle></div>
        <p>For use by EB Academics staff only.</p>
        <lib-login-form (submitLogin)="submitLogin($event)"></lib-login-form>
        <p class="ion-no-margin ion-margin-bottom">
            Forgot password?
            <a
                [queryParams]="queryParams$ | async"
                routerDirection="root"
                routerLink="/account/reset-password"
            >
                <span>Reset here</span> </a
            >.
        </p>
    </section>
</ion-content>
